import { size } from "polished";
import styled, { css } from "styled-components/";
import Captain from "../../img/icons/captain.svg?react";
import ViceCaptain from "../../img/icons/vice-captain.svg?react";

interface IStyledCaptainProps {
  variant?: string;
}

export const StyledCaptain = styled(Captain)<IStyledCaptainProps>`
  ${size(14)};
  color: white;
  margin-top: 0.6rem;

  ${(props) =>
    props.variant === "3xc" &&
    css`
      color: black;
      fill: white;
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(16)}
    right: 10px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    ${size(20)}
    right: 20px;
  }
`;

export const StyledViceCaptain = styled(ViceCaptain)<IStyledCaptainProps>`
  ${size(14)};
  margin-top: 0.6rem;
  color: white;

  ${(props) =>
    props.variant === "3xc" &&
    css`
      color: black;
      fill: white;
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(16)}
    right: 10px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    ${size(20)}
    right: 20px;
  }
`;
